import financeiroApi from './financeiroApi';

const PATH = '/api/v1/backend/transportadora';

export default {
  buscarTransportadoras: async (params) => {
    return financeiroApi.get(`${PATH}`, { params });
  },

  buscarTransportadora: async (id) => {
    return financeiroApi.get(`${PATH}/${id}`);
  },

  criarTransportadora: async (transportadora) => {
    return financeiroApi.post(`${PATH}`, transportadora);
  },

  atualizarTransportadora: async (id, transportadora) => {
    return financeiroApi.put(`${PATH}/${id}`, transportadora);
  },

  removerTransportadoras: async (ids) => {
    return financeiroApi.delete(`${PATH}/${ids}`);
  },

  removerTransportadorasTodosFiltro: async (params) => {
    return financeiroApi.delete(`${PATH}/todosFiltro`, { params });
  },
};
